import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class PixelMilimetrosService {
	// Observables
	private pixelesMilimetrosObservable$ = new BehaviorSubject<number>(0)
	private pixelesMilimetrosObservableCol$ = new BehaviorSubject<number>(0)
	private SliceThicknessObservable$ = new BehaviorSubject<number>(0)
	private loadImageViewerObservable$ = new BehaviorSubject<boolean>(false)
	private rowDicom$ = new BehaviorSubject<number>(0)
	private colDicom$ = new BehaviorSubject<number>(0)
	private pixelSpacing$ = new BehaviorSubject<number>(0)

	// Get's
	// Get Slice Thickness
	getPixelSpacing(): Observable<number> {
		return this.pixelSpacing$.asObservable()
	}

	getSliceThichness(): Observable<number> {
		return this.SliceThicknessObservable$.asObservable()
	}
	// Get Pixel Spacing Row
	getPixelesConvertRow(): Observable<number> {
		return this.pixelesMilimetrosObservable$.asObservable()
	}
	// Get Pixel Spacing Col
	getPixelesConvertCol(): Observable<number> {
		return this.pixelesMilimetrosObservableCol$.asObservable()
	}

	// Get Image Viewer
	getLoadImage(): Observable<boolean> {
		return this.loadImageViewerObservable$.asObservable()
	}
	// Get row dicom
	getRowDicom(): Observable<number> {
		return this.rowDicom$.asObservable()
	}

	// Get row dicom
	getColDicom(): Observable<number> {
		return this.colDicom$.asObservable()
	}

	// Set's
	setPixelSpacing(data: number){
		this.pixelSpacing$.next(data);
	}

	// Set row dicom
	setRowDicom(data: number) {
		console.log("RowDicom", data)
		this.rowDicom$.next(data)
	}

	// Set col dicom
	setColDicom(data: number) {
		console.log("ColDicom", data)
		this.colDicom$.next(data)
	}

	// Set Slice Thickness ->
	setSliceThickness(data: number) {
		console.log("Thickness", data)
		this.SliceThicknessObservable$.next(data)
	}
	// Set Pixel Spacing
	setPixelesConvertCol(data: number) {
		console.log(data)
		this.pixelesMilimetrosObservableCol$.next(data)
	}

	setPixelesConvertRow(data: number) {
		this.pixelesMilimetrosObservable$.next(data)
	}
	// Set Load Image
	setLoadImageViewer(data: boolean) {
		this.loadImageViewerObservable$.next(data)
	}
}
